/**
 * Order History Manager Component
 * Manages inline return/exchange panels for orders (no modal)
 */

export default function orderHistoryManager() {
  return {
    // Track which order's return panel is open (only one at a time)
    activeOrderId: null,

    init() {},

    openReturnForm(orderId) {
      // If clicking same order, toggle it off
      if (this.activeOrderId === orderId) {
        this.activeOrderId = null;
        return;
      }

      // Open the new panel (closes any previously open one)
      this.activeOrderId = orderId;

      // Scroll to the panel after a brief delay for animation
      this.$nextTick(() => {
        const panel = document.getElementById(`return-panel-${orderId}`);
        if (panel) {
          setTimeout(() => {
            panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 100);
        }
      });
    },

    closeReturnForm(orderId) {
      if (this.activeOrderId === orderId) {
        this.activeOrderId = null;
      }
    },

    isFormOpen(orderId) {
      return this.activeOrderId === orderId;
    },
  };
}